<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item">
                <EquipamentoSetorSelect :ckAddTodos="true" v-model:idSelecionado="idSetor"/>
            </div>
            
            <div class="form-item">
                <EquipamentoGrupoSelect :ckAddTodos="true" v-model:idSelecionado="idGrupo"/>
            </div>
        </div>
        

        <div class="row row-space">
            <div class="form-item">
                <EquipamentoFrame v-model:objSelecionado="equipamentoSelecionado"/>
            </div>
        </div>
        

        <div class="row row-space">
           <div class="form-item">
                <label class="label-caption">Lista de endereços (opcional)</label>
                <input type="text" v-model="edListaEnderecos" maxlength="200" />
            </div>
        </div>


        <div class="row-start">
            <button
                class="btn-confirm"
                :disabled="isLoading || cooldownSeconds > 0"
                @click="solicitarEnvio"
            >
                <span v-if="cooldownSeconds === 0">Solicitar Envio</span>
                <span v-else>Solicitar Envio ({{ cooldownSeconds }})</span>
            </button>
            
            <button @click="closeForm">Voltar</button>

            <!-- Toast simples (aparece quando sucesso) -->
            <div v-if="msgSucesso" class="toast-ok">
                <strong>✅ Solicitação enviada!</strong>
                <div class="toast-sub">{{ msgSucesso }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue';
import EquipamentoSetorSelect from '@/selects/EquipamentoSetorSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const edListaEnderecos = ref(null);
const isLoading = ref(false);
const msgAlerta = ref(null);
const msgSucesso = ref(null);

const equipamentoSelecionado = ref();
const idGrupo = ref(0);
const idSetor = ref(0);


// cooldown
const cooldownSeconds = ref(0);
let cooldownTimerId = null;
let toastTimerId = null;


function closeForm() { emit('close'); }


function startCooldown(seconds = 10) {
    // evita múltiplos timers
    if (cooldownTimerId) clearInterval(cooldownTimerId);

    cooldownSeconds.value = seconds;
    cooldownTimerId = setInterval(() => {
        cooldownSeconds.value -= 1;
        if (cooldownSeconds.value <= 0) {
            cooldownSeconds.value = 0;
            clearInterval(cooldownTimerId);
            cooldownTimerId = null;
        }
    }, 1000);
}


function showSuccessToast(text, ms = 4500) {
    msgSucesso.value = text;

    if (toastTimerId) clearTimeout(toastTimerId);
    toastTimerId = setTimeout(() => {
        msgSucesso.value = null;
        toastTimerId = null;
    }, ms);
}


onBeforeMount(() => {
    if (cooldownTimerId) clearInterval(cooldownTimerId);
    if (toastTimerId) clearTimeout(toastTimerId);
})


async function solicitarEnvio() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        startCooldown(10);
        
        const payload = {
            idmunicipio: globalStore.idmunicipio,
            idequipamento: equipamentoSelecionado.value?.id,
            idequipamentogrupo: idGrupo.value,
            idequipamentosetor: idSetor.value,
            idlogin: globalStore.idlogin,
            strparam1: edListaEnderecos.value
        };

        const req = await Api.genericPost('/main/temp/frota/email/alerta', payload);

        const retornoTexto = typeof req === 'string'
            ? req
            : (req?.message || 'E-mail adicionado à fila de transmissão.');
        showSuccessToast(retornoTexto);

    } catch (error) {
        if (cooldownTimerId) clearInterval(cooldownTimerId);
        cooldownTimerId = null;
        cooldownSeconds.value = 0;

        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}

</script>

<style scoped>

.toast-ok {
    position: fixed;
    right: 16px;
    bottom: 16px;
    background: #e7f7ea;
    border: 1px solid #ccefd4;
    color: #1b5e20;
    border-radius: 10px;
    padding: 12px 14px;
    box-shadow: 0 6px 20px rgba(0,0,0,0.12);
    max-width: 420px;
    z-index: 9999;
}

.toast-sub {
    margin-top: 4px;
    font-size: 12px;
    color: #2e7d32;
    font-weight: 700;
}

</style>